<template>
	<div class="bg-color--primary-light--2">
		<div class="bg-color--primary-light--2 mt-5 pt-2 pt-lg-2 mt-lg-8">
			<h4 class="text-center text-black bg-color--primary-light--1">
				قراردادها
			</h4>
			<div class="row ml-2" v-if="ids.length>0">
			<small>برای دانلود خلاصه گزارش قرارداد های انتخاب شده</small>
			<small @click="downloadContractReport()" class="text-info mx-1 report-link" >اینجا</small>
			<small>کلیک کنید</small>
			</div>
			
			<vue-good-table
				:columns="columns"
				ref="contractTable"
				:rows="rows"
				theme="black-rhino"
				:line-numbers="true"
				@on-selected-rows-change="selectionChanged"
				:rtl="true"
				:row-style-class="selectedRows"
				 
				:pagination-options="{
					enabled: false,
					
					mode: 'pages',
					perPage: 20,
					position: 'bottom',
					perPageDropdown: [5, 10, 15, 20],
					dropdownAllowAll: true,
					setCurrentPage: 1,
					nextLabel: '',
					prevLabel: '',
					rowsPerPageLabel: 'تعداد در هر صفحه',
					ofLabel: 'از',
					pageLabel: 'صفحه', // for 'pages' mode
					allLabel: 'همه',
				}"
				:select-options="{
  				 enabled: true,
  				 selectOnCheckboxOnly: true,
  				 selectionText: 'ردیف انتخاب شد ' ,
  				 clearSelectionText: 'پاک کردن',
  				}"
				class="mt-4"
			>
				<template slot="table-row" slot-scope="props" >
					
					<span v-if="props.column.field == 'status'">
						<span v-html="statusShow(props.row.status)"> </span>
					</span>
					<span v-else-if="props.column.field == 'sign_date'">
						{{ props.row.sign_date | moment("jYYYY/jMM/jD ") }}</span
					>
					<span v-else-if="props.column.field == 'invoice_date'">
						{{ props.row.invoice_date | moment("jYYYY/jMM/jD ") }}</span
					>
					<span v-else-if="props.column.field == 'clearing_date'">
						{{ props.row.clearing_date | moment("jYYYY/jMM/jD") }}
					</span>
					<span v-else-if="props.column.field == 'details'">
						<button @click="onRowClick(props.row.customer,props.row.id)" class="btn col-11 btn-info ">مشاهده جزییات قرارداد</button>
						<button @click.prevent="onDownloadReceiptClick(props.row.id)" class="btn col-11 mt-2 btn-info ">دانلود رسید </button>
					</span>
					<span v-else>
						{{ props.formattedRow[props.column.field] }}
					</span>
					
				</template>
			</vue-good-table>
			<div class="d-flex flex-column justify-content-around align-items-center pg-background">
			<nav aria-label="..." class="">
				<ul class="pagination ">
					<li class="page-item">
					<button class="btn btn-primary " @click="onPageChange(pageIndex-1,pageSize)" :disabled="pageIndex==1" >صفحه قبل</button>
					</li>
					<li :class="{'active':item==pageIndex}" class="page-item " @click="onPageChange(item,pageSize)" v-for="item in allPages" :key="item">
					<a class="page-link" >{{item}} <span class="sr-only">{{item}}</span></a>
					</li>
					<li class="page-item">
					<button class="btn btn-primary " @click="onPageChange(pageIndex+1,pageSize)" :disabled="pageIndex==allPages" >صفحه بعد</button>
					</li>

					
					
					
				</ul>
				
				</nav>
				<div class="d-flex flex-row col-6 mx-auto  justify-content-center">
					<div class="mt-1">تعداد قرارداد ها در هر صفحه:</div>
				<select class="form-select form-control col-2 ml-1" @change="onSelectChange" placeholder="test">
				
				<option :selected="pageSize==5" value="5">5</option>
				<option :selected="pageSize==10" value="10">10</option>
				<option :selected="pageSize==20" value="20">20</option>
</select>
				</div>
				</div>
			
		</div>
	</div>
</template>

<script>
// import HeaderSuplier from "../components/shared/HeaderSuplier";
// import VueNumeric from "vue-numeric";
export default {
	data() {
		return {
			allPages:10,
			pageIndex:1,
			pageSize:20,
			ids:[],
			sign_date: "",
			invoice_date: "",
			description: "",
			net_amount: "",
			clearing_date: "",
			number_of_instalment: "",
			downpayment: "",
			status: "",

			contract_id: "",
			vcc_number: "",
			customer: "",
			supplier: "",
			vcc: "",
			customer_fullname: "",
			// clearing_date: "",
			instalment_amount: "",
			total_amount_of_instalments: "",
			instalment_start_date: "",
			end_date: "",
			remaining_amount: "",
			debit_amount: "",
			number_of_pays: "",
			instalment_detail: "",

			columns: [
				{
					label: "آیدی",
					field: "id",
					hidden: true,
					tdClass: "text-center",
					thClass: "text-center",
				},
				{
					label: "شماره قرارداد",
					field: "contract_id",
					hidden: true,
					tdClass: "text-center",
					thClass: "text-center",
					filterable: true,
					filterOptions: {
						enabled: true, // enable filter for this column
						placeholder: "جست و جو بر اساس شماره قرارداد", // placeholder for filter input
						//filterDropdownItems: ['Blue', 'Red', 'Yellow'], // dropdown (with selected values) instead of text input
						filterFn: this.filterFn, //custom filter function that
						trigger: "", //only trigger on enter not on keyup
					},
				},
				{
					label: "آیدی مشتری",
					field: "customer",
					tdClass: "text-center",
					thClass: "text-center",
					hidden: "true",
				},
				{
					label: "نام مشتری",
					field: "customer_fullname",
					tdClass: "text-center",
					thClass: "text-center",
					filterable: true,
					filterOptions: {
						enabled: true, // enable filter for this column
						placeholder: " جست و جو بر اساس نام مشتری", // placeholder for filter input
						filterFn: this.columnFilterFn, //custom filter function that
						trigger: "", //only trigger on enter not on keyup
					},
				},

				{
					label: "مبلغ فاکتور",
					field: "net_amount",
					tdClass: "text-center",
					thClass: "text-center",
					filterable: "true",
				},
				{
					label: "پیش پرداخت",
					field: "downpayment",
					tdClass: "text-center",
					thClass: "text-center",
					sortable: true,
				},
				//clearing_amount
{
					label: "مبلغ تسویه",
					field: "clearing_amount",
					tdClass: "text-center",
					thClass: "text-center",
					sortable: true,
				},
				{
					label: "تاریخ فاکتور",
					field: "invoice_date",
					tdClass: "text-center",
					thClass: "text-center",
				},
				{
					label: "تاریخ امضا قرارداد",
					field: "sign_date",
					tdClass: "text-center",
					thClass: "text-center",
				},
				// clearing_date
				{
					label: "تاریخ تسویه",
					field: "clearing_date",
					//   type: "date",
					tdClass: "text-center",
					thClass: "text-center",
					//   dateInputFormat: "yyyy-MM-dd",
					//   dateOutputFormat: "MMM Do yy",
				},
				{
					label: "وضعیت قرارداد",
					field: "status",
					tdClass: "text-center",
					thClass: "text-center",
					filterable: true,
					filterOptions: {
						enabled: true, // enable filter for this column
						placeholder: "فیلتر ", // placeholder for filter input
						filterDropdownItems: [
							{ value: "0", text: "تایید دریافت پیش پرداخت" },
							{ value: "1", text: " در حال عقد قراداد" },
							{ value: "2", text: "تایید قرارداد و ارسال کالا" },
							{ value: "3", text: "تسویه با فروشگاه" },
							{ value: "4", text: "پرداخت اقساط توسط متقاضی" },
							{ value: "5", text: "تسویه متقاضی و تحویل مدارک" },
							{ value: "6", text: "نکول قطعی" },
							{ value: "7", text: "انصراف متقاضی" },
							// { value: "8", text: "در انتظار تایید فروشگاه" },
						],
						trigger: "", //only trigger on enter not on keyup
					},
				},
				{
					label: "توضیحات",
					field: "description",
					tdClass: "text-center",
					thClass: "text-center",
				},
				{
					label:"جزییات",
					field:"details",
					tdClass:"text-center",
					thClass:"text-center"
				}
			],
			rows: "",
		};
	},
	mounted() {
		this.showContracts(1,20);
		
		
		
	},
	computed: {},
	methods: {
		// statusFn: function(st) {
		//   if (st === "0") {
		//     return '<span class="badge badge-warning" style="height:25px;text-align:center"><b>پرداخت با تاخیر</b></span>';
		//   }
		//   if (st === "1") {
		//     return '<span class="badge badge-success" style="height:25px;"><b>پرداخت به موقع</b></span>';
		//   }
		//   if (st === "2") {
		//     return '<span class="badge badge-danger" style="height:25px;"><b> پرداخت نشده</b></span>';
		//   }
		//   if (st === "3") {
		//     return '<span class="badge badge-secondary" style="height:25px;text-align:center"><b>موعد قسط نرسیده است</b></span>';
		//   }

		//   return;
		// },
		actionBtn: function() {
			return '<button  @click.prevent="showContractDetail" type="button" class="btn btn-primary text-center font-w--400 " style="width:70px;height:35px;font-size: 0.75rem;">جزییات</button>';
		},
		// rowStyleClassFn(row) {
		//   if (row.status === "0") {
		//     return "bg-warning";
		//   }
		//   if (row.status === "1") {
		//     return "bg-success";
		//   }
		//   if (row.status === "2") {
		//     return "bg-danger";
		//   }
		//   if (row.status === "3") {
		//     return "bg-light";
		//   }
		// },
		// eslint-disable-next-line no-unused-vars
		statusShow(st) {
			if (st === "0") {
				return '<span class="badge badge-danger" style="height:25px;text-align:center"><b>تایید دریافت پیش پرداخت</b></span>';
			}
			if (st === "1") {
				return '<span class="badge badge-info" style="height:25px;"><b>در حال عقد قراداد</b></span>';
			}
			if (st === "2") {
				return '<span class="badge badge-success" style="height:25px;"><b> تایید قرارداد و ارسال کالا</b></span>';
			}
			if (st === "3") {
				return '<span class="badge badge-info" style="height:25px;text-align:center"><b>تسویه با فروشگاه</b></span>';
			}
			if (st === "4") {
				return '<span class="badge badge-info" style="height:25px;"><b>پرداخت اقساط توسط متقاضی</b></span>';
			}
			if (st === "5") {
				return '<span class="badge badge-success" style="height:25px;"><b>تسویه متقاضی و تحویل مدارک</b></span>';
			}
			if (st === "6") {
				return '<span class="badge badge-warning" style="height:25px;"><b> نکول قطعی</b></span>';
			}
			if (st === "7") {
				return '<span class="badge badge-danger" style="height:25px;"><b>انصراف متقاضی</b></span>';
			}
			// if (st === "8") {
			// 	return '<span class="badge badge-warning" style="height:25px;"><b>در انتظار تایید فروشگاه</b></span>';
			// }
			if (st === "9") {
				return '<span class="badge badge-danger" style="height:25px;"><b>بدون قرارداد</b></span>';
			}
		},
		onPageChange(pageIndex,pageSize)
		{
			
			this.pageIndex = pageIndex
			this.pageSize = pageSize
			this.showContracts(this.pageIndex,this.pageSize)

		},
		onSelectChange(e)
		{
			
			this.pageSize = e.target.value
			this.pageIndex = 1
			this.showContracts(this.pageIndex,this.pageSize)
		},
		showContracts(pageIndex,pageSize) {
			// console.log("props= ", this.id);
			let load = this.$loading.show();
			this.$store
				.dispatch("getSuppliersContracts", {contract_id:this.contract_id,pageIndex:pageIndex,pageSize:pageSize})
				.then((resp) => {
					(this.sign_date = resp.body.results.sign_date),
						(this.invoice_date = resp.body.results.invoice_date),
						(this.description = resp.body.results.description),
						(this.net_amount = resp.body.results.net_amount),
						(this.number_of_instalment = resp.body.results.number_of_instalment),
						(this.downpayment = resp.body.results.downpayment),
						(this.status = resp.body.results.status),
						(this.supplier_name = resp.body.results.supplier_name),
						(this.contract_id = resp.body.results.contract_id),
						(this.vcc_number = resp.body.results.vcc_number),
						(this.customer = resp.body.results.customer),
						(this.customer_fullname = resp.body.results.customer_fullname),
						(this.clearing_date = resp.body.results.clearing_date),
						(this.instalment_amount = resp.body.results.instalment_amount),
						(this.total_amount_of_instalments =
							resp.body.results.total_amount_of_instalments),
						(this.instalment_start_date = resp.body.results.instalment_start_date),
						(this.end_date = resp.body.results.end_date),
						(this.remaining_amount = resp.body.results.remaining_amount),
						(this.debit_amount = resp.body.results.debit_amount),
						(this.number_of_pays = resp.body.results.number_of_pays),
						(this.instalment_detail = resp.body.results.instalment_detail);
					this.rows = resp.body.results;
					this.allPages = Math.ceil((resp.body.count)/this.pageSize)
				
					
					
		
		


					console.log(resp);
					load.hide();
				})
				.catch((err) => {
					console.log(err);
					load.hide();
				});
			
		},
		onRowClick(customerId,contractId) {
			localStorage.setItem("SupplierCustomerId",customerId)
			this.$router.push(
				"/supplier/customers/" +
					customerId +
					"/contract-detail/" +
					contractId,
			);
		},
		selectionChanged(params)
		{
			
			
			this.ids=[]
			let items = params
			items = items.selectedRows
			// console.log(items)
			// console.log(params + JSON.stringify(params))
			for(let i=0;i<items.length;i++)
			{
				this.ids.push(items[i].id)
			}
			

		},
		onDownloadReceiptClick(id)
		{
			
			this.ids = []
			
			let load = this.$loading.show();
			this.$store
				.dispatch("getSupplierClearReciept", "/contract/supp/"+id+"/clear_receipt/pdf")
				.then((response) => {
					
					let res = response.headers.map['content-disposition'] + ''
					
					let fileName = ((res.split("filename=")[1]+ '').split("\"")[1]+ '').split(".")[0]
					console.log("fileName: " + fileName)
					this.downloadFile(response, fileName,1);
					console.log("response: ", response);
					load.hide();
				})
				.catch((err) => {
					console.warn("error from download_contract");
					console.log("err:  ", err);
					load.hide();
				});
		},
		downloadFile(response, filename,type_) {
			// It is necessary to create a new blob object with mime-type explicitly set
			// otherwise only Chrome works like it should
			var newBlob;
			if(type_==1)
			{
				 newBlob = new Blob([response.body], { type: "application/pdf" });
			}
			else
			{
				 newBlob = new Blob([response.body], { type: "application/xlsx" });
			}
			

			// IE doesn't allow using a blob object directly as link href
			// instead it is necessary to use msSaveOrOpenBlob
			if (window.navigator && window.navigator.msSaveOrOpenBlob) {
				window.navigator.msSaveOrOpenBlob(newBlob);
				return;
			}

			// For other browsers:
			// Create a link pointing to the ObjectURL containing the blob.
			const data = window.URL.createObjectURL(newBlob);
			var link = document.createElement("a");
			link.href = data;
			
			link.download = (type_==1)? filename + ".pdf": filename+".xlsx";
			link.click();
			setTimeout(function() {
				// For Firefox it is necessary to delay revoking the ObjectURL
				window.URL.revokeObjectURL(data);
			}, 100);
		},
		selectedRows(row)
		{
			return this.ids.includes(row.id)?'selectedRowsBackground':''
		},
		downloadContractReport()
		{
			
			this.$store.dispatch("downloadContractReport",this.ids).then((resp)=>{
				console.log(resp)
				this.downloadFile(resp, "report",2);
			}).
			catch((err=>{
				console.log(err)
			}))
		},

		
		},
		
	
	components: {
		// VueNumeric
	},
};
</script>

<style>
.vgt-selection-info-row{
	padding:1% !important;
	color:#004085 !important;
	background-color: #cce5ff !important;
	margin:5px 5px !important; 
	border-color: #b8daff;
}
.vgt-selection-info-row a
{
	margin:5px 5px !important
}
input[type='checkbox'] {
    
    width:20px;
    height:20px;
    background:white;
    border-radius:5px;
    border:2px solid #555;
}
tr input[type='checkbox']:checked 
{
	background-color:blueviolet !important;
}


.green {
	background-color: green;
}

.red {
	background-color: red;
}
.text-black {
	color: black;
}
.selectedRowsBackground
{
	background-color: #9ba4b1;
}
.active a{
	background-color: #5f8dce !important;
	border-radius: 10px;
}
.report-link:hover,a
{
	cursor:pointer
}
.pg-background
{
	margin-top:0px;
	padding-top:3%;
	/* background: linear-gradient(#9ba4b1,#767779); */
	background-color:#dfe5ee ;
	border: 1px solid #9ba4b1d5 ;
	
	
}
</style>
